module.exports = __webpack_public_path__ + "static/media/18ECA46.e37aa00e.jpg";